import React, { useState, useEffect } from "react";
import ReactStars from "react-stars";
import { ApplicationId } from "../../api/url";
import { getTestimonial } from "../../services/testimonialServices";
// import moment from "moment";

const ReviewModal = ({ isOpen, onClose, companyId, title = "Customer Reviews" }) => {
  const [reviewData, setReviewData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const GetDetails = () => {
    setIsLoading(true);
    const payload = {
      applicationId: ApplicationId,
      companyId: Number(companyId),
      testimonialType: "Review",
    };

    getTestimonial(payload)
      .then((res) => {
        setReviewData(res?.data || []);
        setIsLoading(false);
      })
      .catch((err) => {
        console.error("Error fetching testimonials", err);
        setIsLoading(false);
      });
  };

  useEffect(() => {
    if (isOpen) {
      GetDetails();
    }
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/50 flex justify-center items-center z-50 overflow-auto p-4">
      <div className="bg-white rounded-2xl p-6 w-full max-w-2xl relative">
        {/* Close Button */}
        <button
          className="absolute top-2 right-2 bg-red-600 text-white rounded-full p-2 hover:bg-red-700 w-[30px] h-[30px] flex items-center justify-center"
          onClick={onClose}
        >
          ✕
        </button>
        {/* Title */}
        <div className="text-xl font-bold text-[#090548] mb-4 text-center">{title}</div>
        {/* Loader */}
        {isLoading ? (
          <div className="h-[200px]">
            <div className="w-[100%] h-[100%] bg-[#00000066] flex justify-center items-center z-50 top-0 right-0">
              <span class="loader"></span>
            </div>
          </div>
        ) : reviewData.length === 0 ? (
          <div className="text-[#161412] text-[15px] break-words">No reviews found.</div>
        ) : (
          <div className="space-y-6 max-h-[70vh] overflow-y-auto pr-2">
            {reviewData.map((review, index) => (
              <div key={index} className="border-b pb-4 last:border-none">
                <div>
                  <div className="text-[16px] font-bold text-[#161412]">{review.Name}</div>
                  <ReactStars count={5} value={review.Rating} size={20} color2={"#ffd700"} edit={false} />
                  {/* <div className="text-xs text-gray-500">
                    {moment(review.ChangeDate).format("DD MMM YYYY, hh:mm A")}
                  </div> */}
                </div>
                <div
                  className="text-gray-700 text-sm mt-1"
                  dangerouslySetInnerHTML={{ __html: review.TestimonialText || "" }}
                />
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default ReviewModal;
